import type { TabOrientation } from '../nativeTabsTypes.ts';

const axes = {
	horizontal: {
		startEdge: 'left',
		endEdge: 'right',
		previousKey: 'ArrowLeft',
		nextKey: 'ArrowRight',
		pointer: 'clientX',
		rectStart: 'left',
		rectEnd: 'right',
		scrollPos: 'scrollLeft',
		scrollSize: 'scrollWidth',
		clientSize: 'clientWidth',
		scrollKey: 'left',
		scrollPadding: 30,
	},
	vertical: {
		startEdge: 'top',
		endEdge: 'bottom',
		previousKey: 'ArrowUp',
		nextKey: 'ArrowDown',
		pointer: 'clientY',
		rectStart: 'top',
		rectEnd: 'bottom',
		scrollPos: 'scrollTop',
		scrollSize: 'scrollHeight',
		clientSize: 'clientHeight',
		scrollKey: 'top',
		scrollPadding: 0,
	},
} as const;

/** Stable axis descriptors shared by tab navigation, scrolling and drag/drop. */
export const getTabAxis = (orientation: TabOrientation): (typeof axes)[TabOrientation] =>
	axes[orientation];
